import React, { useRef, useState, useEffect } from 'react'

function KnovaImage(props) {
  const {
    imgSource,
    objectFit,
    borderRadius,
    textColor,
    textFontSize,
    textFontWeight,
    textFontFamily,
    textMargin,
    textHeight,
    letterSpacing,
    textAlign
  } = props
  return (
    <div className='sc-image-cont'>
      <img
        width={'100%'}
        height={'100%'}
        src={imgSource}
        style={{
          objectFit: objectFit,
          borderRadius: borderRadius ? borderRadius : '0px'
        }}
      />
    </div>
  )
}
export { KnovaImage }
